<button (click)="onReplyClicked(message())" class="response-button" mat-menu-item>
  <mat-icon [svgIcon]="'reply'"></mat-icon>
  Antworten
</button>
